import { useState, useEffect } from 'react';
import { isScreenWithBigResolution, is1024andSmaller } from '../ui.utils';
const LOAD = 'load';
var TypeEnum = /*#__PURE__*/function (TypeEnum) {
  TypeEnum["min"] = "min";
  TypeEnum["low"] = "low";
  TypeEnum["mid"] = "mid";
  return TypeEnum;
}(TypeEnum || {});
const useBlurredImg = ({
  highQualitySrc
}) => {
  const minQualitySrc = getMinImgLink(highQualitySrc, TypeEnum.min);
  const bestLink = getBestQualityLink(highQualitySrc);
  const [src, setSrc] = useState(minQualitySrc);
  useEffect(() => {
    const img = new Image();
    img.src = bestLink;
    img.addEventListener(LOAD, () => {
      setSrc(bestLink);
    });
  }, [highQualitySrc]);
  return src;
};
const getBestQualityLink = highQualitySrc => {
  if (isScreenWithBigResolution()) {
    return highQualitySrc;
  }
  if (is1024andSmaller()) {
    return getMinImgLink(highQualitySrc, TypeEnum.low);
  }
  return getMinImgLink(highQualitySrc, TypeEnum.mid);
};
const getMinImgLink = (highQualitySrc, type) => {
  const arr = highQualitySrc.split('.');
  arr.splice(arr.length - 1, 0, type);
  return arr.join('.');
};
export { useBlurredImg };